import { useEffect, useState } from "react";
import { images } from "../constants";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();

  const photos = [
    images.VisigaChurch,
    images.student2,
    images.visiga1,
    images.visiga6,
    images.mamamaria2,
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [animate, setAnimate] = useState(false);

  const IMAGE_STAY_TIME = 5000; 
  const TRANSITION_TIME = 1000; 

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(true);

      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % photos.length);
        setAnimate(false);
      }, TRANSITION_TIME);
    }, IMAGE_STAY_TIME + TRANSITION_TIME);

    return () => clearInterval(interval);
  }, [photos.length]);

  return (
    <>
      {/* === Small Devices Layout === */}
      <div className="block lg:hidden w-full flex flex-col items-center justify-center text-black dark:text-white px-6 bg-white dark:bg-gray-900">
        <div
          className="relative w-screen overflow-hidden"
          style={{
            height: "370px",
            backgroundImage: `url(${images.visiga9})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            className={`absolute inset-0 transition-transform duration-1000 ease-in-out ${
              animate ? "-translate-x-full" : "translate-x-0"
            }`}
          >
            <img
              src={photos[currentIndex]}
              alt="Seminary"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <h1 className="text-3xl sm:text-4xl lg:text-5xl text-center tracking-wide mt-8 text-black dark:text-white">
          {t("title")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
            {t("subtitle")}
          </span>
        </h1>

        <p className="mt-4 text-lg text-center text-neutral-900 dark:text-neutral-200 max-w-4xl">
          {t("description")}{" "}
          <span className="font-semibold italic">{t("motto")}</span>
        </p>
      </div>

      {/* === Large Devices Layout === */}
      <div className="hidden lg:block relative min-h-screen overflow-hidden bg-black">
        {/* Background Slideshow */}
        <div className="absolute inset-0">
          {photos.map((photo, index) => (
            <img
              key={index}
              src={photo}
              alt={`Seminary slide ${index + 1}`}
              className={`absolute inset-0 w-full h-full object-cover transition-all duration-1000 ease-in-out ${
                index === currentIndex
                  ? "opacity-100 scale-105"
                  : "opacity-0 scale-100"
              }`}
            />
          ))}
        </div>

        {/* Dark professional overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/35 to-black/75"></div>

        {/* Soft design overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/20"></div>

        {/* Content */}
        <div className="container mx-auto px-6 py-16 relative z-10 flex items-end min-h-screen pb-24">
          <div className="max-w-4xl mx-auto text-center text-white">
            <div className="bg-black/60 backdrop-blur-sm p-10 rounded-2xl shadow-2xl border border-white/10">
              <h1 className="text-4xl xl:text-6xl font-bold tracking-wide text-white">
                {t("title")}{" "}
                <span className="bg-gradient-to-r from-blue-300 to-red-300 text-transparent bg-clip-text">
                  {t("subtitle")}
                </span>
              </h1>

              <p className="mt-5 text-lg xl:text-xl text-neutral-100 leading-relaxed max-w-4xl">
                {t("description")}{" "}
                <span className="font-semibold italic text-white">
                  {t("motto")}
                </span>
              </p>

              {/* Slide indicators */}
              <div className="flex justify-center gap-3 mt-8">
                {photos.map((_, index) => (
                  <span
                    key={index}
                    className={`h-2 rounded-full transition-all duration-500 ${
                      index === currentIndex
                        ? "w-10 bg-white"
                        : "w-2 bg-white/40"
                    }`}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;